/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Parts_HelpInputs */

const en_ticket_parts_help = /** @type {(inputs: Ticket_Parts_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardware for this job and where to collect it.`)
};

const ja_ticket_parts_help = /** @type {(inputs: Ticket_Parts_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この作業に必要な部品と受け取り場所。`)
};

const fr_ticket_parts_help = /** @type {(inputs: Ticket_Parts_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matériel pour cette intervention et où le récupérer.`)
};

const de_ticket_parts_help = /** @type {(inputs: Ticket_Parts_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardware für diesen Auftrag und wo sie abzuholen ist.`)
};

/**
* | output |
* | --- |
* | "Hardware for this job and where to collect it." |
*
* @param {Ticket_Parts_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_parts_help = /** @type {((inputs?: Ticket_Parts_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Parts_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_parts_help(inputs)
	if (locale === "ja") return ja_ticket_parts_help(inputs)
	if (locale === "fr") return fr_ticket_parts_help(inputs)
	return de_ticket_parts_help(inputs)
});